import React from "react"

import { Controller } from "react-hook-form";
import InputDropzoneElement from "./InputDropzoneElement";
//https://react-dropzone.js.org/#section-basic-example

const InputDropzoneControl = ({ editing, required, name, control, label, hint, haserror, multiple, disabled, readonly, className = "" }) => {
    if (!editing) readonly = true;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue=''
            render={({
                field: { onChange, value, name },
                fieldState: { error, invalid },
                formState,
            }) => {
                return (
                    <InputDropzoneElement
                        id={name}
                        name={name}
                        label={label}
                        hint={hint}

                        error={error}
                        invalid={(error) ? invalid : haserror}
                        editing={editing}
                        required={required}
                        multiple={multiple}
                        disabled={disabled}
                        readonly={readonly}

                        className={className}
                        onChange={e =>
                            onChange(multiple ? e.target.files : e.target.files[0])
                        }
                    />
                )
            }}
        />
    )
}

export default InputDropzoneControl;

